var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 4.84446L7.24998 12.1778V20.0311L12.75 17.9686V12.1778L19.1666 4.84446V2.66671C19.1666 1.65419 18.3458 0.833374 17.3333 0.833374H2.66665C1.65412 0.833374 0.833313 1.65419 0.833313 2.66671V4.84446ZM17.3333 2.66671V3.58337H2.66665V2.66671H17.3333ZM3.7701 5.41671H16.2299L11.4174 10.9167H8.5826L3.7701 5.41671ZM9.08331 12.75V17.3856L10.9166 16.6981V12.75H9.08331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2d2cca29bc33839f58846c81fc572cfb.svg";
export { ForwardRef as ReactComponent };